import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserService } from '../user/user.service';
import { GlobalSettingsService } from './global-settings.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../user/user.service";
import * as i3 from "./global-settings.service";
var WhatsNewService = /** @class */ (function () {
    function WhatsNewService(_http, _errorHandler, _userService, _globalSettingsService) {
        this._http = _http;
        this._errorHandler = _errorHandler;
        this._userService = _userService;
        this._globalSettingsService = _globalSettingsService;
        this.localStorageInfo = this._globalSettingsService.localStorageInfo$;
    }
    WhatsNewService.prototype.getWhatsNew = function (version) {
        try {
            var URL_1 = environment.airportsApiUrl + "/whatsnew/?application=Airports&version=" + version;
            var response = this._http.get(URL_1).toPromise();
            // console.log('response: ', response);
            return response;
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    WhatsNewService.prototype.shouldShowWhatsNew = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userPrefWhatsNewVersion, showWhatsNew;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._userService.getWhatsNewVersion()];
                    case 1:
                        userPrefWhatsNewVersion = _a.sent();
                        this._globalSettingsService.loadInfo();
                        showWhatsNew = true;
                        this.localStorageInfo.subscribe(function (val) {
                            if (val && val.whatsNewVersion && val.whatsNewVersion === environment.version) {
                                showWhatsNew = false;
                            }
                        });
                        if (userPrefWhatsNewVersion && userPrefWhatsNewVersion === environment.version) {
                            showWhatsNew = false;
                        }
                        return [2 /*return*/, showWhatsNew];
                }
            });
        });
    };
    WhatsNewService.prototype.displayedWhatsNew = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._globalSettingsService.setInfo({
                            whatsNewVersion: environment.version
                        });
                        return [4 /*yield*/, this._userService.saveWhatsNewVersion()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WhatsNewService.ngInjectableDef = i0.defineInjectable({ factory: function WhatsNewService_Factory() { return new WhatsNewService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler), i0.inject(i2.UserService), i0.inject(i3.GlobalSettingsService)); }, token: WhatsNewService, providedIn: "root" });
    return WhatsNewService;
}());
export { WhatsNewService };
